var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartStep2Next(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#CED9DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74642 5.492C8.07842 5.492 6.99842 6.608 6.99842 8.288L7.01042 8.504H8.03042V8.42C8.03042 7.256 8.64242 6.392 9.68642 6.392C10.6104 6.392 11.3304 7.04 11.3304 7.94C11.3304 8.42 11.1984 8.828 10.9224 9.176C10.6584 9.512 10.0224 10.004 9.03842 10.592C8.21042 11.096 7.62242 11.612 7.31042 12.14C7.01042 12.68 6.83042 13.292 6.77042 14H12.3264V13.1H7.95842C8.07842 12.44 8.52242 11.912 9.83042 11.156C10.8984 10.544 11.5944 10.004 11.9184 9.524C12.2424 9.056 12.4104 8.528 12.4104 7.94C12.4104 6.44 11.3184 5.492 9.74642 5.492Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartStep2Next);
export default __webpack_public_path__ + "static/media/CartStep2Next.f252c23b75c0f4d941bf0eb53bf5af30.svg";
export { ForwardRef as ReactComponent };